'use strict';

var bridgesImport = require('./bridges');

/**
 * @class MutableValues
 * @description This is the core of the mutables values, the target of this is to reduce the number of issues with re-rendering values in the document by creating a more automatic updates without worry about listeners so much since the MutableCore takes care of the updates. So, if you update a mutable value all values in the DOM are automatictly updated  and also its dependencies.This works based on two things, mutables and bridges:
 * A mutable is like variable to store values, but mutables have a update method to change the value of it, so everytime that a mutable is updated, all data rendered in the DOM are updated as well.
 * A bridge works between the data input and the data output, so it can be used to treat the value by doing a calculation for example, or call data from an API, or just run a action for a button using the click event in a button.
 *
 * ### Special HTML attributes
 * - `[mutable]` -> The mutable name, if you want to run a bridge in the middle in order to treat the data or get some data, use the same name and store inte the mutables/bridges.js
 * - `[mutable-type]` -> It can be 'string' | 'number' | 'button'. The default one is 'string' but I'll explain more about them below.
 * - `[mutable-listen]` -> It can be any event appliable for the current tag. For example 'click' | 'keyup'. Or it can be multiples events as well like 'keyup,change,focus'.
 * - `[mutable-dependencies]` -> Here you can add the dependencies that you wants to be updated every time that the mutable was updated.
 * - `[mutable-bridge]` -> By default the bridge that have the same name of the mutable will be used, but you can set an custom one by setting the attribute. Ex: `[mutable-bridge="nameOfTheBridgeHere"]`.
 *
 * @property {object} mutables A mutable is like variable to store values, but mutables have a update method to change the value of it, so everytime that a mutable is updated, all data rendered in the DOM are updated as well.
 * @property {object} bridges A bridge works between the data input and the data output, so it can be used to treat the value by doing a calculation for example, or call data from an API, or just run a action for a button using the click event in a button.
 */
class MutableValues {
    constructor() {
        this.mutables = {};
        this.bridges = bridgesImport;

        this.init();
    }

    /**
     * @description Initialize the mutables grabing the data which already was provided and creating the class.
     * @returns {void}
     */
    init() {
        var mutablesNodes = $('[mutable]');
        var internal = this;
        var mutables = this.mutables;
        var bridges = this.bridges;

        // Creating the mutables
        mutablesNodes.map(function () {
            var $this = $(this);
            var mutableName = $this.attr('mutable');
            var mutableType = $this.attr('mutable-type') || 'string';
            var mutableListen = $this.attr('mutable-listen') ? $this.attr('mutable-listen').replaceAll(' ') : '';
            var customBridge = $this.attr('mutable-bridge');
            var mutableValue;

            // Treating different types of values
            switch (mutableType) {
                case 'string': {
                    mutableValue = $this.val() || $this.attr('value') || $this.html() || '';
                    break;
                }
                case 'number': {
                    mutableValue = Number($this.val() || $this.attr('value') || $this.html());
                    break;
                }
                case 'button': {
                    mutableListen = mutableListen ? mutableListen + ',click' : 'click';
                    mutableValue = null;
                    break;
                }
            }

            // Creating the mutable object
            if (!mutables[mutableName]) {
                mutables[mutableName] = new Mutable({
                    name: mutableName,
                    type: mutableType,
                    value: mutableValue,
                    customBridge: bridges[customBridge],
                });
            } else {
                if (mutableType !== 'button') {
                    var currentMutable = mutables[mutableName];
                    var bridge = currentMutable.customBridge || bridges[mutableName];

                    currentMutable.value = bridge ? bridge(currentMutable.value, internal) : currentMutable.value;
                }
            }

            // Adding the listeners
            mutableListen.split(',').map(function (listen) {
                return $this.on(listen, function (ev) {
                    internal.update(mutableName, ev.target.value);
                });
            });

            // Setting mutable-id to update the values later
            $this.attr('mutable-id', mutables[mutableName].ID);
        });

        // Refreshing all of them
        this.refresh();
    }

    /**
     * @description This method will refresh the values of all mutables, in this case it will use the mutable value stored in the MutableValues class not the rendered data on the DOM.
     * @returns {MutableValues.mutables}
     */
    refresh() {
        var internal = this;
        var mutables = this.mutables;

        Object.keys(mutables).map(function (key) {
            if (mutables[key].type !== 'button') {
                internal.update(key, mutables[key].value);
            }
            return mutables;
        });
    }

    /**
     * @description Use this method to get any updated mutable value.
     * @param {string} name The name of the mutable that you wants to get.
     * @returns {string|number}
     */
    getMutable(name) {
        return this.mutables[name] && this.mutables[name].value;
    }

    /**
     * @description Use this method to update a mutable. When you update a mutable, the value of the mutable inside of the class MutableValues is updated, the mutables rendered on the DOM is updated and also it's dependencies are updated (In case of the mutable has a dependency).
     * @param {string} name The name of the mutable that you wants to update.
     * @param {string|number} newValue The new value of the mutable.
     * @returns {void}
     */
    update(name, newValue) {
        if (!this.mutables[name]) throw new Error(`The mutable value ${name} isn't exist!`);
        var internal = this;
        var mutable = internal.mutables[name];
        var bridges = mutable.customBridge || internal.bridges[name];
        var $mutableNode = $(`[mutable-id='${mutable.ID}']`);
        var dependencies = $mutableNode.attr('mutable-dependencies') || '';

        // Updating mutable object
        switch (mutable.type) {
            case 'string': {
                if (bridges) {
                    mutable.value = bridges(newValue, this);
                } else {
                    mutable.value = newValue;
                }
                break;
            }
            case 'number': {
                mutable.value = bridges ? bridges(newValue || 0, this) : Number(newValue || 0);
                break;
            }
        }

        // Updating mutables in the DOM
        if ($mutableNode.length) {
            $mutableNode.map(function (index, node) {
                var $node = $(this);

                switch (node.nodeName) {
                    case 'INPUT':
                    case 'SELECT': {
                        this.defaultValue = mutable.value;
                        this.value = mutable.value;
                        break;
                    }
                    default: {
                        if (mutable.type !== 'button') {
                            $node.html(mutable.value);
                        }
                    }
                }
            });
        }

        // Updating dependencies
        dependencies.split(',').map(function (dependency) {
            if (dependency) internal.update(dependency, internal.mutables[dependency] ? internal.mutables[dependency].value : '');
            return dependencies;
        });
    }
}

/**
 * @class Mutable
 * This is the mutable object model.
 */
class Mutable {
    constructor(setup = {
        ID: '',
        UID: '',
        name: '',
        type: '',
        value: '' || 0,
        customBridge: Function()
    }) {
        this.ID = setup.ID || genCode(20);
        this.UID = setup.UID || genCode(20);
        this.name = setup.name;
        this.type = setup.type;
        this.value = setup.value;
        this.customBridge = setup.customBridge || null;
    }
}

/**
 * @param {number} size How many characters you wants that the generated code have.
 * @returns {string}
 */
function genCode(size) {
    var chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'k', 'r', 's', 't', 'u', 'v', 'x', 'y', 'w', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var charSize = chars.length - 1;
    var result = '';

    for (let i = 0; i < size; i++) {
        let char = (Math.random() * charSize);
        result += chars[Number(char.toFixed(0))];
    }

    return result;
}

window.mutables = new MutableValues();
